import type { FC, ReactNode } from 'react'
import type { ServiceMotif as ServiceMotifName } from '@/constants/content'

import { useMemo } from 'react'
import { DotCanvas } from '@/components/dots/dot-canvas'

import {
    createGlobeField,
    createMorphField,
    createRippleField,
    createStreamField
} from '@/lib/dots/fields'

interface ServiceMotifProps {
    motif: ServiceMotifName
}

const createField = (motif: ServiceMotifName) => {
    if (motif === 'globe') return createGlobeField(11)
    if (motif === 'ripple') return createRippleField()
    if (motif === 'stream') return createStreamField(5)

    return createMorphField()
}

export const ServiceMotif: FC<ServiceMotifProps> = ({ motif }): ReactNode => {
    const field = useMemo(() => createField(motif), [motif])

    return (
        <DotCanvas
            field={field}
            grid
            cell={6}
            mobileCell={5}
            startTime={4}
        />
    )
}
